'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'cat';
var width = 576;
var height = 512;
var aliases = [128008];
var unicode = 'f6be';
var svgPathData = ['M112 424c0-113.5 79.3-211.2 189.5-235c23 49 72.8 83 130.5 83c11 0 21.7-1.2 32-3.6L464 496l-46 0 0-184 0-19.1-13.6 13.4L296 412.9l0-12.9c0-35.3-28.7-64-64-64l-32 0-8 0 0 16 8 0 32 0c26.5 0 48 21.5 48 48l0 40 0 8 8 0 45.3 0c19.1 0 34.7 15.5 34.7 34.7l0 13.3-32 0c-2.7 0-5.3 0-8 0l-216 0 0-72zM336 16l4.3 0 37.6 45.1 2.4 2.9 3.7 0 96 0 3.7 0 2.4-2.9L523.7 16l4.3 0 0 112c0 53-43 96-96 96s-96-43-96-96l0-112zm48 112a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z', 'M328 0l16 0 3.7 0 2.4 2.9L387.7 48l88.5 0L513.9 2.9 516.3 0 520 0l16 0 8 0 0 8 0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112L320 8l0-8 8 0zm8 128c0 53 43 96 96 96s96-43 96-96l0-112-4.3 0L486.1 61.1 483.7 64 480 64l-96 0-3.7 0-2.4-2.9L340.3 16 336 16l0 112zM112 334.7c29.5-79.5 97.5-141.2 183.5-160.8c1.7 5.2 3.8 10.2 6 15C191.3 212.8 112 310.5 112 424l0 72 216 0 8 0s0 0 0 0l32 0 0-13.3c0-19.1-15.5-34.7-34.7-34.7L288 448l-8 0 0-8 0-40c0-26.5-21.5-48-48-48l-32 0-8 0 0-16 8 0 32 0c35.3 0 64 28.7 64 64l0 12.9L404.4 306.3 418 292.9l0 19.1 0 184 46 0 0-227.6c5.5-1.2 10.8-2.8 16-4.6L480 504l0 8-8 0-62 0-8 0 0-8 0-172.9L299.4 432l33.9 0c28 0 50.7 22.7 50.7 50.7l0 21.3 0 8-8 0-192 0s0 0 0 0l-80 0-8 0 0-8 0-80 0-256c0-30.9-25.1-56-56-56l-8 0 0-16 8 0c39.8 0 72 32.2 72 72l0 166.7zM384 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;